(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gb-case-study"] && !Shopify.designMode) return;
  try {
    
  if (!window.__gbCaseStudyScroll) {
    window.__gbCaseStudyScroll = true;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('.gb-casestudy .cs-btn-scroll');
      if (!link) return;
      var id = link.getAttribute('data-scroll-target');
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return; // no matching anchor — let the default #hash jump handle it
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-compare"] && !Shopify.designMode) return;
  try {
    
  if (!window.__gbCompareScroll) {
    window.__gbCompareScroll = true;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('.gb-compare .cp-btn-scroll');
      if (!link) return;
      var id = link.getAttribute('data-scroll-target');
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return; // no matching anchor — let the default #hash jump handle it
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-faq"] && !Shopify.designMode) return;
  try {
    
  // Optional accordion behaviour: opening one item closes its siblings. Native
  // <details> handles everything else, so this only runs on lists that opt in.
  if (!window.__gbFaqSingle) {
    window.__gbFaqSingle = true;

    document.addEventListener('toggle', function (event) {
      var item = event.target;
      if (!item.matches || !item.matches('.faq-item') || !item.open) return;

      var list = item.closest('[data-gb-faq-single]');
      if (!list) return;

      var siblings = list.querySelectorAll('.faq-item[open]');
      Array.prototype.forEach.call(siblings, function (other) {
        if (other !== item) other.open = false;
      });
    }, true); // capture: the toggle event does not bubble
  }

  if (!window.__gbFaqScroll) {
    window.__gbFaqScroll = true;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('.gb-faq .faq-btn-scroll');
      if (!link) return;
      var id = link.getAttribute('data-scroll-target');
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-final-cta"] && !Shopify.designMode) return;
  try {
    
  if (!window.__gbFinalCtaScroll) {
    window.__gbFinalCtaScroll = true;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('.gb-finalcta .fc-btn-scroll');
      if (!link) return;
      var id = link.getAttribute('data-scroll-target');
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return; // no matching anchor — let the default #hash jump handle it
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-reviews-commercial"] && !Shopify.designMode) return;
  try {
    
  // Shared carousel arrows for the listicle review sections. Guarded so it binds
  // once even though several sections ship this block.
  if (!window.__gbCarousel) {
    window.__gbCarousel = true;

    document.addEventListener('click', function (event) {
      var arrow = event.target.closest('[data-gb-carousel-arrow]');
      if (!arrow) return;

      var root = arrow.closest('[data-gb-carousel]');
      var track = root && root.querySelector('[data-gb-carousel-track]');
      if (!track) return;

      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 1) return;

      var card = track.firstElementChild;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 18;
      var step = card ? card.getBoundingClientRect().width + gap : 320;
      var isNext = arrow.getAttribute('data-gb-carousel-arrow') === 'next';
      var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      if (isNext && track.scrollLeft >= maxScroll - 4) {
        track.scrollTo({ left: 0, behavior: behavior });
      } else if (!isNext && track.scrollLeft <= 4) {
        track.scrollTo({ left: maxScroll, behavior: behavior });
      } else {
        track.scrollBy({ left: isNext ? step : -step, behavior: behavior });
      }
    });
  }

  if (!window.__gbCReviewScroll) {
    window.__gbCReviewScroll = true;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('.gb-creviews .cr-btn-scroll');
      if (!link) return;
      var id = link.getAttribute('data-scroll-target');
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    });
  }

  if (!window.__gbCarouselAutoplay) {
    window.__gbCarouselAutoplay = true;

    var gbReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    var gbBindAutoplay = function (root) {
      if (root.dataset.gbAutoplay === 'on') return;
      var ms = parseInt(root.getAttribute('data-gb-carousel-autoplay'), 10);
      var track = root.querySelector('[data-gb-carousel-track]');
      if (!ms || ms < 1000 || !track) return;
      root.dataset.gbAutoplay = 'on';

      var timer = null;
      var resumeTimer = null;
      var paused = false;
      var onScreen = false;

      function advance() {
        if (paused || !onScreen || document.hidden || gbReduced.matches) return;
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 1) return;
        var card = track.firstElementChild;
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 18;
        var step = card ? card.getBoundingClientRect().width + gap : 320;
        if (track.scrollLeft >= max - 4) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: step, behavior: 'smooth' });
        }
      }

      function run() { if (!timer) timer = setInterval(advance, ms); }
      function halt() { clearInterval(timer); timer = null; }

      // any deliberate interaction wins; autoplay picks up again afterwards
      function holdFor(delay) {
        paused = true;
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { paused = false; }, delay);
      }

      root.addEventListener('pointerenter', function () { paused = true; });
      root.addEventListener('pointerleave', function () { paused = false; });
      root.addEventListener('focusin', function () { paused = true; });
      root.addEventListener('focusout', function () { paused = false; });
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-gb-carousel-arrow]')) holdFor(ms * 2);
      });
      track.addEventListener('touchstart', function () { holdFor(ms * 2); }, { passive: true });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            onScreen = entry.isIntersecting;
            if (onScreen) { run(); } else { halt(); }
          });
        }, { threshold: 0.25 }).observe(root);
      } else {
        onScreen = true;
        run();
      }
    };

    var gbInitAutoplay = function (scope) {
      var el = (scope && scope.querySelectorAll) ? scope : document;
      Array.prototype.forEach.call(el.querySelectorAll('[data-gb-carousel-autoplay]'), gbBindAutoplay);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { gbInitAutoplay(); });
    } else {
      gbInitAutoplay();
    }

    document.addEventListener('shopify:section:load', function (e) { gbInitAutoplay(e.target); });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-reviews-text"] && !Shopify.designMode) return;
  try {
    
  // Shared carousel arrows for the listicle review sections. Guarded so it binds
  // once even though both review sections ship this block.
  if (!window.__gbCarousel) {
    window.__gbCarousel = true;

    document.addEventListener('click', function (event) {
      var arrow = event.target.closest('[data-gb-carousel-arrow]');
      if (!arrow) return;

      var root = arrow.closest('[data-gb-carousel]');
      var track = root && root.querySelector('[data-gb-carousel-track]');
      if (!track) return;

      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 1) return; // nothing to scroll

      var card = track.firstElementChild;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 20;
      var step = card ? card.getBoundingClientRect().width + gap : 320;
      var isNext = arrow.getAttribute('data-gb-carousel-arrow') === 'next';
      var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      if (isNext && track.scrollLeft >= maxScroll - 4) {
        track.scrollTo({ left: 0, behavior: behavior }); // loop to start
      } else if (!isNext && track.scrollLeft <= 4) {
        track.scrollTo({ left: maxScroll, behavior: behavior }); // loop to end
      } else {
        track.scrollBy({ left: isNext ? step : -step, behavior: behavior });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listicle-image"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.listicle-figure .fig-btn-scroll');
    if (!link) return;
    var id = link.getAttribute('data-scroll-target');
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return; // no matching anchor — let the default #hash jump handle it
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    event.preventDefault();
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  });

  // Shared autoplay for silent looping clips across the listicle sections.
  // Guarded so it initialises once even when several sections ship this block.
  // `autoplay` is deliberately NOT set on the elements — it would make every clip
  // on the page download and play at once. preload="none" plus play() on
  // intersection keeps that off the initial load. prefers-reduced-motion leaves
  // the poster frame showing instead.
  if (!window.__listicleClipAutoplay) {
    window.__listicleClipAutoplay = true;

    (function () {
      var observer = null;

      function getObserver() {
        if (observer) return observer;
        if (!('IntersectionObserver' in window)) return null;
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target;
              if (entry.isIntersecting) {
                if (video.getAttribute('preload') === 'none') video.setAttribute('preload', 'auto');
                var played = video.play();
                if (played && typeof played.catch === 'function') played.catch(function () {});
              } else if (!video.paused) {
                video.pause();
              }
            });
          },
          { rootMargin: '200px 0px', threshold: 0.2 }
        );
        return observer;
      }

      function initClips(root) {
        var scope = root && root.querySelectorAll ? root : document;
        var clips = scope.querySelectorAll('.listicle-clip[data-autoplay]');
        if (!clips.length) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        var io = getObserver();
        Array.prototype.forEach.call(clips, function (video) {
          if (video.dataset.observed) return;
          video.dataset.observed = 'true';
          if (io) {
            io.observe(video);
          } else {
            var played = video.play();
            if (played && typeof played.catch === 'function') played.catch(function () {});
          }
        });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initClips(); });
      } else {
        initClips();
      }

      // theme editor re-renders a section on every settings change
      document.addEventListener('shopify:section:load', function (event) { initClips(event.target); });
    })();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listicle-item"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.gb-story-item .si-btn-scroll');
    if (!link) return;
    var id = link.getAttribute('data-scroll-target');
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return; // no matching anchor — let the default #hash jump handle it
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    event.preventDefault();
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  });

  // Shared autoplay for silent looping clips across the listicle sections.
  // Guarded so it initialises once even when several sections ship this block.
  // `autoplay` is deliberately NOT set on the elements — it would make every clip
  // on the page download and play at once. preload="none" plus play() on
  // intersection keeps that off the initial load. prefers-reduced-motion leaves
  // the poster frame showing instead.
  if (!window.__gbClipAutoplay) {
    window.__gbClipAutoplay = true;

    (function () {
      var observer = null;

      function getObserver() {
        if (observer) return observer;
        if (!('IntersectionObserver' in window)) return null;
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target;
              if (entry.isIntersecting) {
                if (video.getAttribute('preload') === 'none') video.setAttribute('preload', 'auto');
                var played = video.play();
                if (played && typeof played.catch === 'function') played.catch(function () {});
              } else if (!video.paused) {
                video.pause();
              }
            });
          },
          { rootMargin: '200px 0px', threshold: 0.2 }
        );
        return observer;
      }

      function initClips(root) {
        var scope = root && root.querySelectorAll ? root : document;
        var clips = scope.querySelectorAll('.gb-clip[data-autoplay]');
        if (!clips.length) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        var io = getObserver();
        Array.prototype.forEach.call(clips, function (video) {
          if (video.dataset.observed) return;
          video.dataset.observed = 'true';
          if (io) {
            io.observe(video);
          } else {
            var played = video.play();
            if (played && typeof played.catch === 'function') played.catch(function () {});
          }
        });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initClips(); });
      } else {
        initClips();
      }

      // theme editor re-renders a section on every settings change
      document.addEventListener('shopify:section:load', function (event) { initClips(event.target); });
    })();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-hero"] && !Shopify.designMode) return;
  try {
    
  // Shared autoplay for silent looping clips across the listicle sections.
  // Guarded so it initialises once even when several sections ship this block.
  // `autoplay` is deliberately NOT set on the elements — it would make every clip
  // on the page download and play at once. preload="none" plus play() on
  // intersection keeps that off the initial load. prefers-reduced-motion leaves
  // the poster frame showing instead.
  if (!window.__gbClipAutoplay) {
    window.__gbClipAutoplay = true;

    (function () {
      var observer = null;

      function getObserver() {
        if (observer) return observer;
        if (!('IntersectionObserver' in window)) return null;
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target;
              if (entry.isIntersecting) {
                if (video.getAttribute('preload') === 'none') video.setAttribute('preload', 'auto');
                var played = video.play();
                if (played && typeof played.catch === 'function') played.catch(function () {});
              } else if (!video.paused) {
                video.pause();
              }
            });
          },
          { rootMargin: '200px 0px', threshold: 0.2 }
        );
        return observer;
      }

      function initClips(root) {
        var scope = root && root.querySelectorAll ? root : document;
        var clips = scope.querySelectorAll('.gb-clip[data-autoplay]');
        if (!clips.length) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        var io = getObserver();
        Array.prototype.forEach.call(clips, function (video) {
          if (video.dataset.observed) return;
          video.dataset.observed = 'true';
          if (io) {
            io.observe(video);
          } else {
            var played = video.play();
            if (played && typeof played.catch === 'function') played.catch(function () {});
          }
        });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initClips(); });
      } else {
        initClips();
      }

      // theme editor re-renders a section on every settings change
      document.addEventListener('shopify:section:load', function (event) { initClips(event.target); });
    })();
  }

  if (!window.__gbOfferScroll) {
    window.__gbOfferScroll = true;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('.gb-offer-hero .oh-btn-scroll');
      if (!link) return;
      var id = link.getAttribute('data-scroll-target');
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return; // no matching anchor — let the default #hash jump handle it
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
